import gql from 'graphql-tag';

export const LINE_LENGTH = 36;

export const USER_QUERY = gql`
  query GetUser($userId: ID) {
    User(id: $userId) {
      id
      name
      email
      phone
      address
      city
      zip
      orgNumber
    }
  }
`;
